// import React from 'react';
import ClientProcessMap from '../components/ClientProcessMap';
import { Container } from 'react-bootstrap';

const ClientLanding = () => {
  return (
    <Container className="mt-4">
      <h2>Client Dashboard</h2>
      <p>Welcome! Here's your custom process map:</p>
      <ClientProcessMap />
    </Container>
  );
};

export default ClientLanding;
